import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import ConditionButton from 'components/atoms/conditionButton';
import ConditionButtonMobile from 'components/atoms/conditionButton/mobile';
import { isMobile } from 'utils/deviceHelper';
import useConfirm from 'utils/useConfirm';
import { addQueryParams } from 'utils/queryHelpers';

const showConfirm = useConfirm({
  message: 'You have unsaved changes, are you sure you want to leave?',
  title: 'Confirm',
});
const conditionFilter = () => {
  const history = useHistory();
  const location = useLocation();
  const [selectedStatus, setSelectedStatus] = useState('');
  const { unsavedComments } = useSelector((state) => state.doctor);
  const device = useSelector((state) => state.user.deviceType);
  const readingCount = useSelector((state) => state.doctor.readingsCount);
  const {
    doctor: { applyFilters, clearComments },
  } = useDispatch();
  const handleClick = (status) => {
    setSelectedStatus(status);
    applyFilters({ status });
    addQueryParams({ history, location }, { status, page: 1 });
  };

  useEffect(() => {
    if (location.search === '') setSelectedStatus('');
  }, [location]);

  const ignoreUnsavedChanges =
    (ok, cancel) =>
    async (...props) => {
      let confirm = true;
      if (Object.keys(unsavedComments).length) {
        confirm = await showConfirm();
      }
      if (confirm) {
        clearComments();
        return ok && ok(...props);
      }
      return cancel && cancel(...props);
    };

  return (
    <div>
      <div className="activity-header">
        <h3 className="activity-header-mb-3">Real Time Patient Readings</h3>
      </div>
      <Row>
        <Col xs={4}>
          {isMobile(device) && (
            <ConditionButtonMobile
              status="critical"
              count={readingCount.critical}
              text="Critical"
              handleClick={ignoreUnsavedChanges(handleClick)}
            />
          )}
          {!isMobile(device) && (
            <ConditionButton
              status="critical"
              count={readingCount.critical}
              text="Critical"
              handleClick={ignoreUnsavedChanges(handleClick)}
              selectedStatus={selectedStatus}
            />
          )}
        </Col>
        <Col xs={4}>
          {isMobile(device) && (
            <ConditionButtonMobile
              status="risk"
              count={readingCount.risk}
              text="At-Risk"
              handleClick={ignoreUnsavedChanges(handleClick)}
            />
          )}
          {!isMobile(device) && (
            <ConditionButton
              status="risk"
              count={readingCount.risk}
              text="At-Risk"
              handleClick={ignoreUnsavedChanges(handleClick)}
              selectedStatus={selectedStatus}
            />
          )}
        </Col>
        <Col xs={4}>
          {isMobile(device) && (
            <ConditionButtonMobile
              status="normal"
              count={readingCount.normal}
              text="Normal"
              handleClick={ignoreUnsavedChanges(handleClick)}
            />
          )}
          {!isMobile(device) && (
            <ConditionButton
              status="normal"
              count={readingCount.normal}
              text="Normal"
              handleClick={ignoreUnsavedChanges(handleClick)}
              selectedStatus={selectedStatus}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default conditionFilter;
